module.exports = __webpack_public_path__ + "img/armless_statues.378d7e83.jpg";